import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';

import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShFormTextComplexBaseComponent } from '../../form-text/form-text.module';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'sh-form-email-complex-base',
    templateUrl: './form-email-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormEmailComplexBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, AsyncPipe]
})
export class ShFormEmailComplexBaseComponent extends ShFormTextComplexBaseComponent implements OnInit, OnDestroy {
    private readonly EMAIL_INPUT_REGEX: RegExp = new RegExp(/^\S+@\S+\.\S+$/);

    @Output() validationChange: EventEmitter<boolean> = new EventEmitter();

    initListeners() {
        const input$: Observable<string> = this.control.valueChanges;

        const firstChar$: Observable<string> = input$.pipe(
            filter(value => !!value),
            take(1)
        );

        firstChar$.pipe(takeUntil(this.destroy$)).subscribe(() => this.indeterminate$.next(false));

        input$.pipe(takeUntil(this.destroy$)).subscribe(value => {
            const isEmailValid: boolean = this.isEmailValid(value);

            if (isEmailValid) {
                this.propagateChange(new FormValue(value, FormValueState.SET));
            } else {
                this.propagateChange(new FormValue(null, FormValueState.UNSET));
            }

            this.validationChange.emit(isEmailValid);
        });
    }

    private isEmailValid(email: string | null): boolean {
        if (!email || email === '') {
            return true;
        }

        const isCorrectFormat: boolean = this.EMAIL_INPUT_REGEX.test(email);

        return isCorrectFormat;
    }
}
